import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { IProfileAttributeDocument, IProfileAttributeRequest, IProfileAttributeResponse } from '../../profile-attributes/bp-profiles-attributes.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';

@Injectable()
export class BPProfilesCaveatsDataService {
  constructor(
    private httpDataService:HttpDataService,
    private authService:AuthService
  ) {
    /**/
  }

  public getUploadDocumentUrl(profileId:number, caveatId:number):string {
    return this.authService.authenticatedUrl(`rest/bpprofiles/profiles/${profileId}/caveats/${caveatId}/documents`);
  }

  public getDocumentUrl(profileId:number, caveatId:number, documentId:number):string {
    return this.authService.authenticatedUrl(`rest/bpprofiles/profiles/${profileId}/caveats/${caveatId}/documents/${documentId}`);
  }

  public getCaveats(profileId:number):Promise<IProfileAttributeResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/caveats`,
      undefined,
      undefined,
      'Error loading caveats'
    );
  }

  public saveCaveats(profileId:number, profileAttributes:IProfileAttributeRequest[]):Promise<IProfileAttributeResponse> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/caveats`,
      undefined,
      profileAttributes,
      undefined,
      'Error saving caveats'
    );
  }

  public updateCaveatDocument(profileId:number, caveatId:number, document:IProfileAttributeDocument):Promise<IProfileAttributeDocument> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/caveats/${caveatId}/documents/${document.id}`,
      undefined,
      document,
      undefined,
      'Error updating document'
    );
  }

  public deleteCaveatDocument(profileId:number, caveatId:number, document:IProfileAttributeDocument):Promise<void> {
    return this.httpDataService.doDELETE(
      `rest/bpprofiles/profiles/${profileId}/caveats/${caveatId}/documents/${document.id}`,
      undefined,
      undefined,
      'Error deleting document'
    );
  }
}